export const ONCE_CAPTURE_EVENT_OPTIONS = { once: true, capture: true };
export const PASSIVE_CAPTURE_EVENT_OPTIONS = { passive: true, capture: true };
export const PASSIVE_EVENT_OPTIONS = { passive: true };
export const CAPTURE_EVENT_OPTIONS = { capture: true };
